export default __webpack_public_path__ + "static/media/figuremap50.8e590c5d.png";